import React, {useState} from 'react';
import {
	CRUD_UPDATE_MANY_SUCCESS,
	FETCH_END,
	TopToolbar,
	UPDATE,
	sanitizeListRestProps,
} from 'react-admin';
import { Button } from 'react-admin';
import { useMutation } from 'react-admin';
import { useNotify } from 'react-admin';
import { useRefresh } from 'react-admin';
import { useDispatch } from 'react-redux';
import { isEmptyObject } from 'utils/validation/required';

import { ArticlePreviewButton } from '../../../components/dialogs/ArticlePreviewButton';
import { TERMINAL_ALL_VALUE } from '../../../components/filters/ToggleTerminalsFilter';
import { UserRole } from '../../../entities';
import { ExportArticleButton } from './ExportArticleButton';

export const ArticlesActions = (props) => {
	const {
		selectedCurrency,
		className,
		exporter,
		filterValues,
		onEdit,
		isEdit,
		...rest
	} = props;

	const notify = useNotify();
	const dispatch = useDispatch();
	const refresh = useRefresh();

	if (!props.defaultData && !isEmptyObject(props.data)) {
	  props.setDefaultData(structuredClone(props.data));
	}
	let isFilterTerminal = false;
	let terminalId = undefined;
	if (filterValues && filterValues["terminal_id"]) {
		terminalId = filterValues["terminal_id"][0];
		if (terminalId !== TERMINAL_ALL_VALUE) isFilterTerminal = true;
	}

	const [mutate, { loading }] = useMutation({
		type: 'updateManyArray',
		resource: props.resource,
	}, {
		withDeclarativeSideEffectsSupport: true,
		onSuccess: ({ data }) => {
			dispatch({
				type: CRUD_UPDATE_MANY_SUCCESS,
				payload: { data },
				meta: {
					resource: props.resource,
					notification: {
						body: 'ra.notification.updated',
						level: 'info',
						messageArgs: {
							smart_count: 1,
						}
					},
					fetchResponse: UPDATE,
					fetchStatus: FETCH_END
				},
			})
			props.onSuccess && props.onSuccess();
		},
		onFailure: (error) => {
			notify(error.message, "error");
		}
	});

	// TODO: change logic: user should not can change currency in edit mode, so we should pass only one currency param to backend
	const onSubmit = () => {
		const payload = {
			ids: props.selectedIds,
			data: Object.fromEntries(
				Object.entries(props.selectedFields).map(([key, value]) => [
					key,
					{ ...value, currency: selectedCurrency.currency }
				])
			),
		};
		mutate({ payload });
		props.cancelEdit()
		props.setDefaultData(null);
		refresh();
	}

	const onCancel = () => {
		props.cancelEdit()
		Object.assign(props.data , props.defaultData)
		props.setDefaultData(null);
	}
	const isAdmin = props.permissions && props.permissions.role === UserRole.admin;
	
	return (
		<TopToolbar className={className} {...sanitizeListRestProps(rest)}>			
			{!isEdit ? <ExportArticleButton filters={filterValues} terminalId={terminalId} disabled={!isFilterTerminal} /> : null}
			{!isEdit ? <ArticlePreviewButton filters={filterValues} terminalId={terminalId} disabled={!isFilterTerminal}/> : null}
			{!isEdit && isAdmin ? <Button label="Edit" onClick={onEdit} disabled={!isFilterTerminal}/> : null}
			{isEdit && isAdmin ? <Button label="Apply changes" onClick={onSubmit} /> : null}
			{isEdit && isAdmin ? <Button label="Cancel" onClick={onCancel} /> : null}
		</TopToolbar>
	);
};
